<div class="text-center mb-8">
  <div
    class="w-16 h-16 rounded-2xl mx-auto mb-5 flex items-center justify-center bg-deep-green shadow-lg shadow-[#0A3D2F]/20"
  >
    <ng-icon size="30" name="lucideCreditCard" class="text-white" />
  </div>
  <h3 class="text-xl sm:text-2xl font-bold text-deep-green mb-2">Mobile Money Payment</h3>
  <p class="text-sm text-muted-foreground max-w-md mx-auto">
    Enter your payment details to settle the application fee.
  </p>
</div>

<form [formGroup]="paymentForm" (ngSubmit)="onPaymentSubmit()" class="space-y-5 max-w-md mx-auto">
  <!-- Fee summary -->
  <div
    hlmCard
    class="rounded-xl p-4 border-0 bg-deep-green text-white shadow-lg shadow-[#0A3D2F]/15"
  >
    <div class="flex justify-between items-center mb-2 pb-2 border-b border-white/10">
      <span class="text-sm text-white/70">Application Fee</span>
      <span class="font-bold text-lg text-gold">
        {{ sessionService.formSubData()?.user?.amount | currency: 'GHS ' : 'symbol' : '1.2-2' }}
      </span>
    </div>
    <div class="flex justify-between items-center">
      <span class="text-sm text-white/70">Processing</span>
      <span class="text-xs font-bold uppercase tracking-wider text-white bg-white/10 px-2.5 py-1 rounded-full">
        Due Now
      </span>
    </div>
  </div>

  <div hlmFieldGroup>
    <fieldset hlmFieldSet>
      <div hlmFieldGroup class="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div hlmField class="col-span-full">
          <label hlmFieldLabel for="payment_number">Mobile Money Number</label>
          <input
            hlmInput
            id="payment_number"
            type="tel"
            maxlength="10"
            pattern="^0\d{9}$"
            formControlName="payment_number"
            placeholder="Enter your Momo number"
            class="w-full px-4 py-3 rounded-lg border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
            required
          />
          <p hlmFieldDescription class="text-xs">
            Enter the 10-digit mobile money number registered for prompt deduction
          </p>
          <hlm-field-error>{{ getErrorMessagePayment('payment_number') }}</hlm-field-error>
        </div>

        <div hlmField>
          <label hlmFieldLabel for="network">Network</label>
          <hlm-select id="network" formControlName="network" [itemToString]="itemToStringNetworkList">
            <hlm-select-trigger
              class="w-full rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
            >
              <hlm-select-value placeholder="Select an option" />
            </hlm-select-trigger>
            <hlm-select-content *hlmSelectPortal>
              <hlm-select-group>
                <hlm-select-label>Payment Network</hlm-select-label>
                @for (list of networkList; track list.value) {
                  <hlm-select-item
                    [value]="list.value"
                    class="data-highlighted:bg-primary/10 data-highlighted:text-primary"
                  >
                    {{ list.label }}
                  </hlm-select-item>
                }
              </hlm-select-group>
            </hlm-select-content>
          </hlm-select>
          <hlm-field-error>{{ getErrorMessagePayment('network') }}</hlm-field-error>
        </div>

        <div hlmField>
          <label hlmFieldLabel for="serial_number">Serial Number</label>
          <input
            hlmInput
            id="serial_number"
            formControlName="serial_number"
            type="text"
            class="w-full px-4 py-3 font-mono font-extrabold tracking-wide rounded-lg border bg-slate-50 text-deep-green focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 transition duration-150 ease-in-out"
            required
            [readOnly]="true"
          />
          <hlm-field-error>{{ getErrorMessagePayment('serial_number') }}</hlm-field-error>
        </div>
      </div>
    </fieldset>
  </div>

  <div
    class="flex items-start gap-3 p-3.5 rounded-xl bg-gold-light border border-gold/25 text-xs text-muted-foreground"
  >
    <ng-icon name="lucideInfo" class="size-4 text-gold shrink-0 mt-0.5" />
    <span>
      Upon clicking <strong class="text-deep-green">Pay Now</strong>, an authorization prompt will be
      sent to your phone. Approve it with your Mobile Money PIN to complete the transaction.
    </span>
  </div>

  <button
    hlmBtn
    type="submit"
    [disabled]="isPaymentLoading()"
    class="w-full py-3.5 rounded-xl font-bold text-sm tracking-wide transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 disabled:hover:translate-y-0"
  >
    @if (isPaymentLoading()) {
      <hlm-spinner class="text-base md:text-lg" />
      <span class="ml-2">Sending payment request...</span>
    } @else {
      <span>Pay Now</span>
    }
  </button>

  <p class="text-center text-xs text-muted-foreground">
    <ng-icon size="14" name="lucideLockKeyhole" class="inline-block align-text-bottom text-gold" />
    Your payment information is encrypted and secure
  </p>
</form>
